import { useSelector } from "react-redux";
import { selectCurrentDataSetId } from "../../../../store/selectors/metaDataSelectors";
import { DataSetIds } from "../../../../utilities/DimensionNames";

const useCanAddCustomFields = () => {
  const dataSetId = useSelector(selectCurrentDataSetId);
  return !dataSetId || dataSetId === DataSetIds.GeneralAndMemo || dataSetId === DataSetIds.PortfolioMonitoring;
};

export default useCanAddCustomFields;
